module.exports = __webpack_public_path__ + "img/宣传_214.8c2e4053.jpg";